import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../utils/firebase";

const addToWaitlist = async ({ fullName, email, phone, sex, country }) => {
    console.log(fullName, email, phone, country, sex);
  try {
    console.log("Adding to waitlist with data:", { fullName, email, phone, sex, country });
    const res = await addDoc(collection(db, "waitlist"), {
      fullName,
      email,
      phone,
      sex,
      country,
      createdAt: serverTimestamp(),
    });

    console.log("here")

    console.log("User added with ID:", res.id);
    return { success: true, id: res.id };
  } catch (error) {
    console.error("Error adding to waitlist:", error);
    return { success: false, error };
  }
};

export default addToWaitlist;